<template>
  <!--通知公告-->
  <div class="content Announcements">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <!--面包屑-->
          <div class="layui-row">
            <div class="layui-col-md8">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Formation/Inforamtion' }">会议资讯管理</el-breadcrumb-item>
                <el-breadcrumb-item>会议资讯列表</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div
            class="layui-row"
            style="margin-top: 20px;"
          >
            <div class="layui-col-md2">
              <el-button
                @click="add_new"
                type="primary"
              >新建资讯</el-button>
            </div>
          </div>
          <div class="layui-row">
            <table
              id="test"
              lay-filter="test"
            ></table>
            <script
              type="text/html"
              id="barDemo"
            >
            <a
              class="layui-btn layui-btn-xs"
              lay-event="edit"
              style="color: #FFFFFF;"
            >编辑</a>
            <a
              class="layui-btn layui-btn-danger layui-btn-xs"
              lay-event="del"
              style="color: #FFFFFF;"
            >删除</a>
            </script>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"; //时间处理

export default {
  name: "Information",
  data () {
    return {
      msg: "",
      content: "",
    };
  },

  methods: {
    // 公共方法
    handlePublics () {
      let _this = this;
      this.$nextTick(() => {
        layui.use(["jquery", "element", "table", "form"], function () {
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var table = layui.table;
          let url = _this.APIurl.API.api.zixinlists;
          _this.$get(url).then((res) => {
            console.log(res);
            if (res.code == 1)
            {
              table.render({
                elem: "#test",
                data: res.posts.list,
                cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
                cols: [
                  [
                    { field: "name", title: "资讯标题" },
                    { field: "conference_name", title: "所属会议" },
                    { field: "source", title: "媒体" },
                    { field: "jump_link", title: "链接" },
                    { field: "author", title: "作者" },
                    {
                      field: "create_time",
                      title: "创建时间",
                      templet: function (d) {
                        return moment
                          .unix(d.create_time)
                          .format("YYYY.MM.DD:hh:mm:ss");
                      },
                    },
                    {
                      fixed: "right",
                      title: "操作",
                      toolbar: "#barDemo",
                      width: 160,
                    },
                  ],
                ],
                page: true,
              });
            }
          });
          /* 监听编辑/删除 */
          //监听工具条
          table.on("tool(test)", function (obj) {
            var data = obj.data;
            if (obj.event === "edit")
            {
              _this.$router.push({
                name: "AddInforamtion",
                query: { id: data.id },
              });
            } else if (obj.event === "del")
            {
              layer.confirm("真的删除行么", function (index) {
                let url = _this.APIurl.API.api.removezixun;
                var params = {
                  id: data.id,
                };
                _this.$delet(url, params).then((res) => {
                  if (res.code == 1)
                  {
                    obj.del();
                    layer.close(index);
                  }else{
                    layer.msg(res.msg);
                  }
                });
              });
            }
          });

          element.render();
          form.render();
          table.render();
        });
      });
    },
    add_new () {
      this.$router.push({ path: "/Formation/AddInforamtion" });
    },
  },
  mounted () {
    // 公共方法
    this.handlePublics();
  },
  updated () {
    // 公共方法
    this.handlePublics();
  },
};
</script>

<style scoped>
.Announcements .layui-form-label {
  width: auto;
}
.Announcements .layui-input-block {
  margin-left: 90px;
}
</style>
